import React, { useState } from 'react';
import { Box, TextField, Button, Grid, FormControlLabel, Switch, Paper, Typography } from '@mui/material';

const ClientForm = ({ client, onSubmit, isSubmitting, buttonText = 'Salvar' }) => {
  const [formData, setFormData] = useState({
    name: client?.name || '',
    website: client?.website || '',
    logo: client?.logo || '',
    active: client?.active !== undefined ? client.active : true
  });
  
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Clear error when field is edited
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  const handleSwitchChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked
    });
  };

  const validate = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Nome é obrigatório';
    }
    
    if (formData.website && !isValidUrl(formData.website)) {
      newErrors.website = 'URL inválida';
    }
    
    if (formData.logo && !isValidUrl(formData.logo)) {
      newErrors.logo = 'URL inválida para logo';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validate()) {
      onSubmit(formData);
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        {client ? 'Editar Cliente' : 'Novo Cliente'}
      </Typography>
      
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nome do Cliente"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              required
              variant="outlined"
            />
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Website"
              name="website"
              value={formData.website}
              onChange={handleChange}
              error={!!errors.website}
              helperText={errors.website}
              variant="outlined"
              placeholder="https://exemplo.com"
            />
          </Grid>
          
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="URL do Logo"
              name="logo"
              value={formData.logo}
              onChange={handleChange}
              error={!!errors.logo}
              helperText={errors.logo}
              variant="outlined"
              placeholder="https://exemplo.com/logo.png"
            />
          </Grid>
          
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.active}
                  onChange={handleSwitchChange}
                  name="active"
                  color="primary"
                />
              }
              label="Cliente Ativo"
            />
          </Grid>
          
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="submit"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Salvando...' : buttonText}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default ClientForm;
